// export const LOGOUT_OK = state => {
//   state.user = {}
//   state.roles = null
//   state.loggedIn = false
// }

export const getProspekBank = (state, res) => {
  state.prospek_banks = res
}

export const prospekDetail = (state, res) => {
  state.detail = res
}

export const formProspekBank = (state, res) => {
  state.form = res
}

export const getProbability = (state, res) => {
  state.probabilities = res
}

export const getProbabilityActivity = (state, res) => {
  state.probabilityActivities = res
}

export const getPBStatus = (state, res) => {
  state.pbStatuses = res
}

export const pbStatusForm = (state, val) => {
  state.pbStatusForm = val
}

export const pbTableSort = (state, val) => {
  let oldVal = state.pbSort

  if (oldVal.sortBy == val) {
    state.pbSort.sortDesc = !oldVal.sortDesc
  } else {
    state.pbSort = {
      sortBy: val,
      sortDesc: true
    }
  }
}

export const getNotifApproval = (state, val) => {
  state.notifs = val
}
